import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import GettingStartedWithAI from 'src/app/organisms/Homepage/GettingStartedWithAI/GettingStartedWithAI';

const CallToAction = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-none']}
      paddingSm={['spacing-4xl', 'spacing-none']}
    >
      <GettingStartedWithAI />
    </SectionLayout>
  );
};

export default CallToAction;
